/** @format */
import React, { FunctionComponent } from 'react';
import { SimCardServiceTypeAllowedParam, SimCardServiceTypeAllowedParamMap } from '../../../../interfaces/collections/SimCardServiceInterface';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import I18n from '../../../../components/Translate/I18n';
import { getFeatureVerbName } from '../../../../modules/features/FeaturesTypes';
import { Typography } from '@material-ui/core';
import { BoolTranslateHelper, BoolTranslateTrueFalseHelper } from '../../../../helpers/BoolTranslateHelper';

const _ = require('underscore');

type OplSimCardServiceTypeSdgParamType = {
    param: SimCardServiceTypeAllowedParam;
    id: number;
};

export const OplSimCardServiceTypeSdgParam: FunctionComponent<OplSimCardServiceTypeSdgParamType> = ({ param, id }): React.ReactElement => {
    const parameters = JSON.parse(param.parameters);

    const processParams = (params: SimCardServiceTypeAllowedParamMap, paramName: string): React.ReactElement => {
        return (
            <GridItem xs={12} key={'root_main_params_loop_' + paramName + id}>
                <I18n trans="prov:feature.param_name" valueObject={{ param_name: paramName }} />
                <GridContainer>
                    <GridItem xs={6}>
                        <I18n trans="prov:feature.required" />
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans={BoolTranslateHelper(params.required)} />
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans="prov:feature.default" />
                    </GridItem>
                    <GridItem xs={6}>
                        <React.Fragment>
                            {typeof params.default === 'boolean' && <I18n trans={BoolTranslateTrueFalseHelper(params.default)} />}
                            {typeof params.default !== 'boolean' && params.default}
                            {typeof params.default !== 'boolean' && !params.default && <I18n trans="prov:feature.empty_value" />}
                        </React.Fragment>
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans="prov:feature.type" />
                    </GridItem>
                    <GridItem xs={6}>{params.type}</GridItem>
                    {params.allowedValue && (
                        <React.Fragment key={'key_app' + paramName + params.param_name + params.type}>
                            <GridItem xs={6}>
                                <I18n trans="prov:feature.allowed_value" />
                            </GridItem>
                            <GridItem xs={6}>
                                {params.allowedValue.map((allowedValue) => (
                                    <React.Fragment key={'app' + allowedValue.value ?? paramName}>
                                        {typeof params.default !== 'boolean' && allowedValue.value}
                                        {typeof allowedValue.value === 'boolean' && <I18n trans={BoolTranslateTrueFalseHelper(allowedValue.value)} />}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </GridItem>
                        </React.Fragment>
                    )}
                </GridContainer>
            </GridItem>
        );
    };

    const result: Array<React.ReactElement> = [];
    if (parameters) {
        _.mapObject(parameters, (val: SimCardServiceTypeAllowedParamMap, key: string): any => {
            result.push(processParams(val, key));
        });
    }

    return (
        <GridContainer>
            <GridItem xs={12}>
                <hr />
                <GridContainer>
                    <GridItem xs={6}>
                        <Typography variant="subtitle2">
                            <I18n trans="prov:feature.operation_name" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <Typography variant="subtitle2">
                            <I18n trans={'prov:feature.' + getFeatureVerbName(param.operationVerbId)} />
                        </Typography>
                    </GridItem>
                    {result.map((item) => item)}
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};
